import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@bingads-webui-react/primitive';
import { Dialog, DialogType, DialogFooter } from '@bingads-webui-react/fabric-control';

export function FilterRemoveModal(props) {
  return (
    <Dialog
      hidden={false}
      onDismiss={() => props.onCancel()}
      dialogContentProps={{
        type: DialogType.normal,
        title: props.title,
        closeButtonAriaLabel: props.closeButtonAriaLabel,
        subText: props.removePromptText,
      }}
      modalProps={{
        isBlocking: false,
        className: props.classeName,
      }}
    >
      <DialogFooter>
        <Button btnStyle="primary" onClick={() => props.onRemove()} className="remove">{props.removeText}</Button>
        <Button btnStyle="secondary" onClick={() => props.onCancel()} className="cancel">{props.cancelText}</Button>
      </DialogFooter>
    </Dialog>
  );
}

FilterRemoveModal.propTypes = {
  removePromptText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  closeButtonAriaLabel: PropTypes.string.isRequired,
  removeText: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  classeName: PropTypes.string.isRequired,
};
